import { useLocalization } from "@fluent/react";

interface SectionErrorProps {
  errorMessage?: string;
  // input the user hasn't saved is blocking another section
  showUnsavedError: boolean;
}

const SectionError = ({
  errorMessage,
  showUnsavedError,
}: SectionErrorProps) => {
  const { l10n } = useLocalization();
  if (!errorMessage && !showUnsavedError) return null;
  return (
    <div className="message-content negative">
      <span className="narmi-icon-info margin--right--m" />
      {errorMessage || l10n.getString("recipient-drawer-unsaved-section")}
    </div>
  );
};

export default SectionError;
